import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { faSave } from '@fortawesome/free-solid-svg-icons';
import { Subscription, forkJoin } from 'rxjs';
import { Alert } from 'src/app/classes/alert';
import { BaseClass } from 'src/app/classes/base_class';
import { RealClub, RealClubResponse } from 'src/app/classes/real_club';
import { RealPlayer, RealPlayerResponse } from 'src/app/classes/real_player';
import { User, UserResponse } from 'src/app/classes/user';
import { AbstractService } from 'src/app/services/abstract.service';
import { AlertboxComponent } from '../alertbox/alertbox.component';
import { Booking, Goal, RealMatch, RealMatchResponse, Score, Substitution } from 'src/app/classes/real_match';
import { RealClubService } from 'src/app/services/real-club.service';
import { RealPlayerService } from 'src/app/services/real-player.service';
import { TacticmoduleService } from 'src/app/services/tacticmodule.service';
import { TacticModule, TacticModuleResponse } from 'src/app/classes/tactic_module';
import { RealCompetitionService } from 'src/app/services/real-competition.service';
import { RealCompetition } from 'src/app/classes/real_competition';
import { FilterRealClub } from 'src/app/classes/filterRealClub';
import { infoData } from 'src/app/classes/real_match';
import { RealScardSummary } from 'src/app/classes/realscardsummary';
import { RealScardsummaryService } from 'src/app/services/real-scardsummary.service';
import { RealMatchService } from 'src/app/services/real-match.service';
import { NotificationService } from 'src/app/services/notification.service';

@Component({
  selector: 'app-single-realmatch',
  templateUrl: './single-realmatch.component.html',
  styleUrls: ['./single-realmatch.component.scss']
})
export class SingleRealmatchComponent implements OnInit {
  rplayer = {}
  rsDate = {}
  options = [10, 30, 50, 70, 90];
  selectedOptions: { [playerId: number]: number } = {};

  selectOption(playerId: number, option: number) {
    this.selectedOptions[playerId] = option;
  }
  dateRealMatch = ""
  dateOfNow = new Date().toISOString().slice(0, 19);
  
  
  busy: Subscription;
  faPlus = faSave;
  rels: Array<any>;
  singleResponse: UserResponse | RealClubResponse | RealPlayerResponse;
  cols: any;
  varCustomClass = 'accordionCustomStyle';

  @Input() id: number;
  @Input() single: RealMatch;
  @Input() componentService: AbstractService;
  @Input() routePart: string;
  @Output() pathListEvent = new EventEmitter<any[]>();
  @ViewChild('alertbox1', { static: false }) alertbox1: AlertboxComponent;
  rplayer1: RealPlayer[];
  rplayer2: RealPlayer[];
  tmp_realclub1_lineup: any[];
  tmp_realclub2_lineup: any[];
  dataInfo: infoData;
  homeClub = "";
  visitorClub = "";
  tacticModules: TacticModule[];
  matchDate: Date;
  competitions: RealCompetition[];
  filterRealClub: FilterRealClub;
  realClubList: RealClub[];

  constructor(private router: Router, public realclubService: RealClubService, public realPlayerService: RealPlayerService, public tacticModule: TacticmoduleService, public realCompetitionService: RealCompetitionService, public realScardSummaryService: RealScardsummaryService, public realMatchService: RealMatchService, public notificationService: NotificationService) { }

  ngOnInit(): void {
    this.tacticModule.list2().subscribe(
      (data: TacticModuleResponse) => {
        this.tacticModules = data.payload;
      }
    );
    if (this.id > 0) {
      this.getSingle(this.id);
    } else {
      this.single.real_competition_id = -1;
      this.busy = this.realCompetitionService.list2().subscribe((competitions) => {
        const ccmp: RealCompetition[] = competitions.payload.filter(c => c.active == 1);
        this.competitions = ccmp.sort((a, b) => a.description > b.description ? 1 : -1);
      });
    }
  }
  selectClub(rc1?: boolean, rc2?: boolean){
    let filter: Array<any> | null = null;
    filter = [];
    if(rc1 == true){
      const $rclub1 = this.realclubService.get(this.single['realclub1_id']);
      filter['realclub_id'] = this.single['realclub1_id'];
      const $rplayer1 = this.realPlayerService.list2(filter);
      this.busy = forkJoin([$rclub1, $rplayer1]).subscribe(([rclub1, rplayer1]) => {
          for (let rp1 of rplayer1.payload) {
            rp1.ctrl_convocato = false;
            if (this.isInLineUp(this.single.realclub1_lineup, rp1.id)) {
              rp1.ctrl_convocato = true;
            }
            if (this.isInLineUp(this.single.realclub1_bench, rp1.id)) {
              rp1.ctrl_convocato = true;
            }

            let x: RealPlayer = new RealPlayer();
            x = this.objCopy(rp1, x)
          }

          rplayer1.payload = this.orderByBasic(rplayer1.payload);

          this.rplayer1 = rplayer1.payload;
          this.homeClub = rclub1.payload.description;

        });
    }
    else if (rc2 == true){
      const $rclub2 = this.realclubService.get(this.single['realclub2_id']);
      filter['realclub_id'] = this.single['realclub2_id'];
      const $rplayer2 = this.realPlayerService.list2(filter);
      this.busy = forkJoin([$rclub2, $rplayer2]).subscribe(([rclub2, rplayer2]) => {

          rplayer2.payload = this.orderByBasic(rplayer2.payload);
        
          for (let rp2 of rplayer2.payload) {
            rp2.ctrl_convocato = false;
            if (this.isInLineUp(this.single?.realclub2_lineup, rp2.id)) {
              rp2.ctrl_convocato = true;
            }
            if (this.isInLineUp(this.single.realclub2_bench, rp2.id)) {
              rp2.ctrl_convocato = true;
            }

            let x: RealPlayer = new RealPlayer();
            x = this.objCopy(rp2, x)
          }
          this.rplayer2 = rplayer2.payload;
          this.visitorClub = rclub2.payload.description;

        });
    }
  }
  selectCompetition($event) {
    let filter: Array<any> | null = null;
    filter = [];
    filter['realcompetition_id'] = $event.target.value;
    this.busy = this.realclubService.list2(filter, true).subscribe(rclubs => {
      this.realClubList = rclubs.payload.sort((a, b) => a.common_mame > b.common_mame ? 1 : -1);
    });
  }

  navigateTo() {
    this.router.navigate([`/${this.routePart}/${this.id}/table`]);
  }

  getControlType(control_name: string): string {
    if (control_name in this.single.controls) {
      return this.single.controls[control_name];
    }
    return '';
  }

  toArray(obj: any): any[] {
    if (!obj) {
      return [];
    }
    Object.keys(obj).map(key => obj[key])
    return obj;
  }

  removePlayer(obj: RealPlayer, lineup) {
    // this.single[lineup].splice(obj, 1);
    this.single[lineup] = this.single[lineup].filter(item => item['id'] !== obj.id);

    const xx: RealPlayer = this.rplayer1.find((item) => item.id == obj.id);
    const yy: RealPlayer = this.rplayer2.find((item) => item.id == obj.id);
    if (xx) {
      xx.ctrl_convocato = false;
    }
    if (yy) {
      yy.ctrl_convocato = false;
    }
  }

  addPlayer(obj: RealPlayer, lineup, tacticmodule_id) {
    const roleToAdd = obj.ruolo;
    const checkRole = tacticmodule_id ? this.checkFormazioneModulo(lineup, tacticmodule_id, roleToAdd) : true;
    if (checkRole == false) {
      const provaAlert: Alert = new Alert();
      provaAlert.msg = 'Troppi giocatori per il ruolo ' + roleToAdd;
      provaAlert.timeout = 5000;
      provaAlert.type = 'danger';
      this.alertbox1.alerts = [];
      this.alertbox1.alerts.push(provaAlert);
      return false;
    } else {
      obj.ctrl_convocato = true;
      const rp = {
        'shirtNumber': obj['shirtNumber'],
        'calciatore': obj['calciatore'],
        'ruolo': obj['ruolo'],
      }
      if (!this.single[lineup]) {
        this.single[lineup] = Array();
      }
      this.single[lineup].unshift(obj);
      this.single[lineup] = this.orderByBasic(this.single[lineup]);
    }
  }

  /**
   *
   * @param payload dato in ingresso
   * @param obj dato in uscita
   * @returns obj
   */
  objCopy(payload, obj) {
    obj.ctrl_convocato = false;
    for (const key in payload) {
      if (Object.prototype.hasOwnProperty.call(this.single, key)) {
        obj[key] = payload[key];
      }
    }
    return obj;
  }

  isInLineUp(players: RealPlayer[], realplayer_id: number): Boolean {
    if (!players) return false;
    for (let item of players) {
      if (item.id == realplayer_id) {
        return true;
      }
    }
    return false;
  }

  /**
   *
   * move on-top in sequenza
   *  A, C, D, P
   *  1, 2, 3, 4
   * @param ruolo
   * @returns
   */
  ruolo2order(ruolo) {
    switch (ruolo) {
      case 'A':
        return 1;
      case 'C':
        return 2;
      case 'D':
        return 3;
      case 'P':
        return 4;
      default:
        return 0;
    }
  }

  orderByBasic(a: RealPlayer[]) {
    return a.sort((a: RealPlayer, b: RealPlayer) => {
      const r1 = this.ruolo2order(a.ruolo);
      const r2 = this.ruolo2order(b.ruolo);
      return (r1 > r2 ? -1 : 1);
    });
  }

  checkFormazioneModulo(lineup: string, tacticmodule_id: number, role: string, saving = 0): boolean {
    // Se non c'è un modulo selezionato, permetto sempre l'inserimento
    if (!tacticmodule_id) {
      return true;
    }
    // const isLineup = lineup.includes('lineup');
    const modulo = this.tacticModules.find(x => x.id == tacticmodule_id);
     // Se il modulo non viene trovato, permetto l'inserimento
    if (!modulo) {
      return true;
    }
    const qtaA = modulo.ea + modulo.pc + modulo.t + modulo.sp + saving;
    const qtaC = modulo.cc + modulo.cf + saving;
    const qtaD = modulo.dc + modulo.dl + saving;
    const qtaP = 1 + saving;
    let lineupA = 0;
    let lineupC = 0;
    let lineupD = 0;
    let lineupP = 0;
    for (const rpl of this.single[lineup]) {
      if (rpl.ruolo == 'A') lineupA++;
      if (rpl.ruolo == 'C') lineupC++;
      if (rpl.ruolo == 'D') lineupD++;
      if (rpl.ruolo == 'P') lineupP++;
    }
    switch (role) {
      case 'A':
        if (lineupA < qtaA) { return true; }
        break;

      case 'C':
        if (lineupC < qtaC) { return true; }
        break;

      case 'D':
        if (lineupD < qtaD) { return true; }
        break;

      case 'P':
        if (lineupP < qtaP) { return true; }
        break;

      default:
        return false;
    }
    return false;
  }

  parseISOString(s) {
    const b = s.split(/\D+/);
    return new Date(b[0], --b[1], b[2], b[3], b[4], b[5]);
  }

  getSingle(id: number) {
    const isNew = id == 0 ? true : false;
    if (id == 0) id = 1;
    this.busy = this.componentService.get(id).subscribe(
      (data: RealMatchResponse) => {
        if (!isNew) {
          // this.single = data.payload;
          for (const key in data.payload) {
            if (Object.prototype.hasOwnProperty.call(this.single, key)) {
              this.single[key] = data.payload[key];
            }
          }
        }
        this.matchDate = this.parseISOString(this.single['utcDate']);

        // this.cols = data.admin_info.cols.filter((c) => c.indexOf('.') == -1); // rimuovo i campi fk
        let filter: Array<any> | null = null;
        filter = [];

        const $rclub1 = this.realclubService.get(this.single['realclub1_id']);
        filter['realclub_id'] = this.single['realclub1_id'];
        const $rplayer1 = this.realPlayerService.list2(filter);

        const $rclub2 = this.realclubService.get(this.single['realclub2_id']);
        filter['realclub_id'] = this.single['realclub2_id'];
        const $rplayer2 = this.realPlayerService.list2(filter);


        const $realmatch = this.realMatchService.get_by_match_id(this.single['id'])
        this.single.realclub1_lineup = this.orderByBasic(this.single.realclub1_lineup);
        this.single.realclub2_lineup = this.orderByBasic(this.single.realclub2_lineup);

        this.busy = forkJoin([$rclub1, $rclub2, $rplayer1, $rplayer2, $realmatch]).subscribe(([rclub1, rclub2, rplayer1, rplayer2, realmatch]) => {
          this.pathListEvent.emit([rclub1.payload.common_mame + ' - ' + rclub2.payload.common_mame, `${this.routePart}/${this.single.id}`]);
          for (let rp1 of rplayer1.payload) {
            rp1.ctrl_convocato = false;
            if (this.isInLineUp(this.single.realclub1_lineup, rp1.id)) {
              rp1.ctrl_convocato = true;
            }
            if (this.isInLineUp(this.single.realclub1_bench, rp1.id)) {
              rp1.ctrl_convocato = true;
            }

            let x: RealPlayer = new RealPlayer();
            x = this.objCopy(rp1, x)
          }

          rplayer1.payload = this.orderByBasic(rplayer1.payload);
          rplayer2.payload = this.orderByBasic(rplayer2.payload);
          this.dateRealMatch = realmatch.payload.utcDate
          // Number() evita il mismatch string/number con il confronto === del template
          for (const rp of [...rplayer1.payload, ...rplayer2.payload]) {
            this.selectedOptions[rp.id] = rp.titolarita_potenziale == null ? rp.titolarita_potenziale : Number(rp.titolarita_potenziale);
          }
          for (let rp2 of rplayer2.payload) {
            rp2.ctrl_convocato = false;
            if (this.isInLineUp(this.single?.realclub2_lineup, rp2.id)) {
              rp2.ctrl_convocato = true;
            }
            if (this.isInLineUp(this.single.realclub2_bench, rp2.id)) {
              rp2.ctrl_convocato = true;
            }

            let x: RealPlayer = new RealPlayer();
            x = this.objCopy(rp2, x)
          }

          this.rplayer1 = rplayer1.payload;
          this.rplayer2 = rplayer2.payload;
          this.homeClub = rclub1.payload.description;
          this.visitorClub = rclub2.payload.description;

        });
      },
      (err) => {
        console.log('ERRORE: ' + JSON.stringify(err.error.description));
      }
    );

  }

  getRels(rel: string) {
    // this.httpdata.get('/' + rel).subscribe(
    //   (data) => {
    //     this.rels.push({ class_name: rel, list: data });
    //   },
    //   (err) => {
    //     console.error(err);
    //     alert('ERRORE: ' + JSON.stringify(err.error.description));
    //   }
    // );
  }

  getRelated(rel: string) {
    // return this.rels.find((r) => {
    //   return r.class_name == rel;
    // }).list;
  }

  saveItem(partial = false) {
    //RealPlayer Save titolarita
    const controls = {}
    const ctrl_convocato = ""
    let playersToUpdate = [];
    let filterplayer = ""
    // Ottengo gli id dei realplayers
    Object.entries(this.selectedOptions).forEach(([playerIdStr, selectedValue]) => {
      filterplayer += playerIdStr + ","        
    })
    //Rimuovo l'ultimo carattere
    filterplayer = filterplayer.slice(0, -1);
    if (!partial) {
    if (this.single.realclub1_lineup && this.single.realclub1_lineup.length != 11) {
      const sndAlert: Alert = new Alert();
      sndAlert.msg = 'Non hai schierato abbastanza giocatori per il team ' + this.homeClub;
      sndAlert.timeout = 5000;
      sndAlert.type = 'danger';
      this.alertbox1.alerts = [];
      this.alertbox1.alerts.push(sndAlert);
      return false;
    }
    if (this.single.realclub2_lineup && this.single.realclub2_lineup.length != 11) {
      const sndAlert: Alert = new Alert();
      sndAlert.msg = 'Non hai schierato abbastanza giocatori per il team ' + this.visitorClub;
      sndAlert.timeout = 5000;
      sndAlert.type = 'danger';
      this.alertbox1.alerts = [];
      this.alertbox1.alerts.push(sndAlert);
      return false;
    }
    if (this.id > 0) {
      const rolesToCheck = ['A', 'C', 'D'];
      for (const roleToCheck of rolesToCheck) {
        // console.log(this.checkFormazioneModulo('realclub1_lineup', this.single['tactic_module1_id'], roleToCheck));
        const checkRole1 = this.single['tactic_module1_id'] ? this.checkFormazioneModulo('realclub1_lineup', this.single['tactic_module1_id'], roleToCheck, 1) : true;
        const checkRole2 = this.single['tactic_module2_id'] ? this.checkFormazioneModulo('realclub2_lineup', this.single['tactic_module2_id'], roleToCheck, 1) : true;
        if (checkRole1 == false || checkRole2 == false) {
          const sndAlert: Alert = new Alert();
          const team = (checkRole1 == false ? this.homeClub : this.visitorClub);
          sndAlert.msg = 'Troppi giocatori per il ruolo ' + roleToCheck + ' del team ' + team;
          sndAlert.timeout = 5000;
          sndAlert.type = 'danger';
          this.alertbox1.alerts = [];
          this.alertbox1.alerts.push(sndAlert);
          return false;
        }
      }
    } else {

      let _score: Score = { away: "", awayTeam: "0", home: "", homeTeam: "0" };
      this.single.score_fullTime = _score;
    }
    }
    this.single['utcDate'] = this.dateToLocalString(this.matchDate);;
    const payload = BaseClass.cleanup(this.single);
    // const payload = this.single;
    this.single.description = '';
    if (this.single.id == 0) {
      this.busy = this.componentService.create(payload).subscribe({
        next: () => {
          const provaAlert: Alert = new Alert();
          provaAlert.msg = "salvataggio riuscito";
          provaAlert.timeout = 5000;
          provaAlert.type = 'normal';
          this.alertbox1.alerts = [];
          this.alertbox1.alerts.push(provaAlert)
          this.router.navigate([`/${this.routePart}/list`]);
        },
        error: (err: HttpErrorResponse) => {
          let msg = '';
          if ('errors' in err.error) {
            msg = JSON.stringify(err.error.errors)
          } else {
            msg = err.error.status + ' - ' + err.error.payload;
          }
          const provaAlert: Alert = new Alert();
          provaAlert.msg = msg;
          provaAlert.timeout = 5000;
          provaAlert.type = 'danger';
          this.alertbox1.alerts = [];
          this.alertbox1.alerts.push(provaAlert)
        },
      });
    } else {
      if(this.single['status'] != 'FINISHED'){
        //Ottengo la lista dei realplayers
        this.realPlayerService.getList(filterplayer).subscribe({
          next: (response) => {
              playersToUpdate = response.payload
              playersToUpdate.forEach(player => {
                if (this.selectedOptions[player.id] !== undefined) {
                  player.titolarita_potenziale = this.selectedOptions[player.id];
                }
              });

              if (playersToUpdate.length > 0){
                this.saveRealPlayers(playersToUpdate)
              }
          },
          error: (err) => {
            console.error('Errore durante il recupero dei dati del giocatore', err);
          }
        })
        this.busy = this.componentService.update(this.single.id, payload).subscribe({
          next: () => {
            const provaAlert: Alert = new Alert();
            provaAlert.msg = "Salvataggio riuscito";
            provaAlert.timeout = 5000;
            provaAlert.type = 'primary';
            this.alertbox1.alerts = [];
            this.alertbox1.alerts.push(provaAlert);
            // this.router.navigate([`/${this.routePart}/${this.single.id}`]);
          },
          error: (err: HttpErrorResponse) => {
            let msg = '';
            if ('errors' in err.error) {
              msg = JSON.stringify(err.error.errors)
            } else {
              msg = err.error.status + ' - ' + err.error.payload;
            }
            const provaAlert: Alert = new Alert();
            provaAlert.msg = msg;
            provaAlert.timeout = 5000;
            provaAlert.type = 'danger';
            this.alertbox1.alerts = [];
            this.alertbox1.alerts.push(provaAlert)
          },
        });
      }
      else{
        const sndAlert: Alert = new Alert();
          sndAlert.msg = 'Operazione non consentita: il match è già iniziato o terminato.';
          sndAlert.timeout = 5000;
          sndAlert.type = 'danger';
          this.alertbox1.alerts = [];
          this.alertbox1.alerts.push(sndAlert);
          //this.getSingle(this.id);
          //return false;
      }
      
    }
    
  }
  setMatchNotification(realmatch_id: number){
    this.busy = this.notificationService.postMatchNotification(realmatch_id).subscribe({
      next: (response) => {
        console.log('invio notifiche alla fine del match:', response);
      }
    })

  }
  dateToLocalString(date: Date): string {
    const pad = (n: number) => String(n).padStart(2, '0');
    const d = new Date(date);
    return `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
  }

  getDatiInfo(){
    if (!this.dataInfo) {
      this.dataInfo = new infoData();
    }
    this.dataInfo.matchday = this.single.matchday
    this.dataInfo.utcDate = this.dateToLocalString(this.matchDate);
    this.dataInfo.status = this.single.status
    this.dataInfo.venue = this.single.venue
    return this.dataInfo
  }
  saveItemInfo(info?: boolean){
    if(this.single.id != 0 && this.single.id != null){
      const payload = this.getDatiInfo() 
      this.busy = this.realMatchService.updateInfo(this.single.id, payload, info).subscribe({
        next: (response) => {
          const provaAlert: Alert = new Alert();
          provaAlert.msg = "Salvataggio dati info riuscito";
          provaAlert.timeout = 5000;
          provaAlert.type = 'primary';
          this.alertbox1.alerts = [];
          this.alertbox1.alerts.push(provaAlert);
          if(response.payload.status == "FINISHED"){
            this.setMatchNotification(this.single.id);
          }
          // this.router.navigate([`/${this.routePart}/${this.single.id}`]);
        },
        error: (err: HttpErrorResponse) => {
          let msg = '';
          if ('errors' in err.error) {
            msg = JSON.stringify(err.error.errors)
          } else {
            msg = err.error.status + ' - ' + err.error.payload;
          }
          const provaAlert: Alert = new Alert();
          provaAlert.msg = msg;
          provaAlert.timeout = 5000;
          provaAlert.type = 'danger';
          this.alertbox1.alerts = [];
          this.alertbox1.alerts.push(provaAlert)
        },
      });
    } else{
      this.saveItem()
    }
  }
  onDateChange(newDate: Date) {
    this.single.utcDate = this.dateToLocalString(newDate);
  }
  parse(o) {
    return JSON.parse(o);
  }

  saveRealPlayers(playersToUpdate){
    const realplayersList = {"real_players": playersToUpdate}
    this.realPlayerService.updateList(realplayersList).subscribe({
      next: (response) => {
        // console.log('Aggiornamento riuscito per il giocatore:', response.payload);
      },
      error: (err) => {
        console.error('Errore durante l\'aggiornamento dei giocatori', err);
      }
    });
  }
  
  getPlayerFlag(playerId: number, flag: string): boolean {
    const player = 
      this.rplayer1?.find(p => p.id === playerId) || 
      this.rplayer2?.find(p => p.id === playerId);
    // console.log(playerId, " Giocatore: ", player['calciatore']);
    return player ? player[flag] === 1 : false;
  }

}
